<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ fireInsuranceCompanyName }}</span>
		<app-button
			(click)="create()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateCompanyButton"
			>Create</app-button
		>
	</div>
</ng-template>

<ng-template #fireInsuranceCompanyTemplate let-item>
	<div class="flex flex-col" [testHook]="testHooks.FireInsuranceCompanyItemDiv">
		<span class="font-bold truncate">{{ item.name | titlecase }}</span>
		<div class="flex truncate">
			<span class="text-sm"
				>{{ item.address?.street }}, {{ item?.address?.city }}</span
			>
		</div>
	</div>
</ng-template>

<div class="py-2">
	<app-auto-complete
		placeholder="Fire insurance Company"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewTemplate },
			{
				items: (fireInsuranceCompany$ | async),
				template: fireInsuranceCompanyTemplate,
				title: 'Fire insurance company',
				noResultsMessage: 'No Fire insurance companies found',
				type: dropdownSelect.SELECT_FIRE_INSURANCE_COMPANY,
			},
		]"
		[(ngModel)]="fireInsuranceCompanyName"
		name="dual-dropdown-1"
		[minSearchTerm]="2"
		[loading]="loading"
		width="w-full"
		[label]="label"
		(onSelect)="onSelectFireInsuranceCompany($event)"
		(debounce)="search($event)"
		[testHook]="testHooks.DualDropdown1AutoComplete"
	>
	</app-auto-complete>
</div>
